const buttonJs = function () {
  // Ripple button bird
  if (document.body.classList.contains('home')) {
    const audioBird = document.querySelector('.ripple-button-container audio');
    document.querySelector('.ripple-button-container button').addEventListener('click', (e) => {
      e.currentTarget.classList.toggle('on');
      if (e.currentTarget.classList.contains('on')) {
        audioBird.play();
      }
      else {
        audioBird.pause();
      }
    })
    // To stop animation on scroll
    const topStop = document.getElementById("welcome-section").offsetTop;
    window.addEventListener('scroll', () => {
      if (window.scrollY > (topStop - 500)) {
        if (document.querySelector('.ripple-button-container button').classList.contains('on')) {
          audioBird.pause();
          document.querySelector('.ripple-button-container button').classList.remove('on');
        }
      }
    })
    // Btn scroll to next
    document.querySelector('.birds-container .arrow-down').addEventListener('click', () => {
      document.getElementById('welcome-section').scrollIntoView();
    })
  }
  
}

addFunctionOnWindowLoad(buttonJs);